import {stylesheet} from "typestyle";
import * as React from "react";
import {PropsWithChildren} from "react";
import {classNames, IconNames, MaterialIcon} from "@variocube/cube-ui";
import {AWESOME_BAR_HEIGHT} from "./common";

interface AwesomeBarItemProps {
    label?: string;
    startIcon?: IconNames;
    endIcon?: IconNames;
    onClick?: () => void;
    className?: string;
}

export function AwesomeBarItem({label, startIcon, endIcon, onClick, children, className}: PropsWithChildren<AwesomeBarItemProps>) {
    return (
        <div className={classNames(styles.item, className)} onClick={onClick}>
            {startIcon && <MaterialIcon className={styles.startIcon} icon={startIcon}/>}
            {label}
            {children}
            {endIcon && <MaterialIcon className={styles.endIcon} icon={endIcon}/>}
        </div>
    )
}

const styles = stylesheet({
    item: {
        flex: "0 0 auto",
        display: "flex",
        flexFlow: "row nowrap",
        alignItems: "center",
        padding: "0 0.75em",
        height: AWESOME_BAR_HEIGHT,
    },
    startIcon: {
        fontSize: "1.5em",
        marginRight: "0.25em",
    },
    endIcon: {
        fontSize: "1.5em",
        marginLeft: "0.25em",
    }
});